export default __webpack_public_path__ + "static/media/whyBrokerVTGMIcon6.2efbbf7b.webp";